import { render, staticRenderFns } from "./AnnouncementPush.vue?vue&type=template&id=794ccf1d"
import script from "./AnnouncementPush.vue?vue&type=script&lang=js"
export * from "./AnnouncementPush.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPush.vue?vue&type=style&index=0&id=794ccf1d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports